import { render, staticRenderFns } from "./NewPassForm.vue?vue&type=template&id=cfc68f56&scoped=true"
import script from "./NewPassForm.vue?vue&type=script&lang=js"
export * from "./NewPassForm.vue?vue&type=script&lang=js"
import style0 from "./NewPassForm.vue?vue&type=style&index=0&id=cfc68f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc68f56",
  null
  
)

export default component.exports